import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'

@Component({
  selector: 'form-search-proposal-client',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-search-proposal-client.component.html',
  styleUrl: './form-search-proposal-client.component.scss',
})
export class FormSearchProposalClientComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private proposalStatusService: ProposalStatusService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')
  datepickerEmission = viewChild<MatDatepicker<any>>('dateEmission')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search: string = ''

  listStatus: any[] = []
  //   [
  //   { id: 0, description: 'Todos' },
  //   { id: 1, description: 'Aprovada' },
  //   { id: 2, description: 'Pendente' },
  //   { id: 3, description: 'Aguardando compras' },
  //   { id: 8, description: 'Devolvido Compras' },
  //   { id: 4, description: 'Análise do cliente' },
  //   { id: 5, description: 'Não aceita pelo cliente' },
  //   { id: 6, description: 'Cancelada' },
  //   { id: 7, description: 'Em aberto' },
  // ]

  ngOnInit() {
    this.getListStatus()
    this.createForm()
  }

  ngOnChanges() {
    // this.updateSearch()
  }

  getListStatus() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listStatus = response.data
        this.listStatus.unshift({ id: 0, descricao: 'Todos' },)
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  // updateSearch() {
  //   this.formSearch.get('search')?.setValue(this.search ?? '')
  // }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      client: [''],
      subClient: [''],
      event: [''],
      tgCode: [''],
      consultantClient: [''],
      consultantTg: [''],
      status: [0],
      dateStart: [''],
      dateEnd: [''],
      dateEmission: [''],
    })
  }

  sendSearch(search: boolean = true) {
    console.log('form: ', this.formSearch)
    if (search && this.checkSearch()) {
      const searchModel = {
        clienteId: 0,
        nomeCliente: this.formSearch.get('client')!.value,
        subClienteId: 0,
        nomeSubCliente: this.formSearch.get('subClient')!.value,
        codigoTg: this.formSearch.get('tgCode')!.value,
        consultorId: 0,
        nomeConsultor: this.formSearch.get('consultantClient')!.value,
        nomeEvento: this.formSearch.get('event')!.value,
        formaPagamentoId: 0,
        prazo: '',
        statusPropostaId: this.formSearch.get('status')!.value,
        statusPropostaDescricao: '',
        consultorComercial: this.formSearch.get('consultantTg')!.value,
        dataInicio:
          this.formSearch.get('dateStart')!.value != ''
            ? moment(this.formSearch.get('dateStart')!.value).format(
                'DD/MM/YYYY',
              )
            : '',
        dataFim:
          this.formSearch.get('dateEnd')!.value != ''
            ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
            : '',
        dataEmissao:
          this.formSearch.get('dateEmission')!.value != ''
            ? moment(this.formSearch.get('dateEmission')!.value).format(
                'DD/MM/YYYY',
              )
            : '',
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('subClient')!.setValue('')
      this.formSearch.get('event')!.setValue('')
      this.formSearch.get('consultantClient')!.setValue('')
      this.formSearch.get('consultantTg')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEmission')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')
      this.formSearch.get('status')!.setValue(0)
      this.formSearch.get('tgCode')!.setValue('')

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('client')!.value.trim().length > 0 ||
      this.formSearch.get('subClient')!.value.trim().length > 0 ||
      this.formSearch.get('event')!.value.trim().length > 0 ||
      this.formSearch.get('consultantClient')!.value.trim().length > 0 ||
      this.formSearch.get('consultantTg')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value ||
      this.formSearch.get('dateEmission')!.value ||
      this.formSearch.get('status')!.value == 0 ||
      this.formSearch.get('status')!.value != ''
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd' | 'dateEmission') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    } else if (type == 'dateEmission') {
      this.datepickerEmission()?.open()
    }
  }
}
